module.exports = __webpack_public_path__ + "static/HKGrotesk-Medium-3ad5dd32c02ce75da937fd27e4834bea.ttf";